module.exports = __webpack_public_path__ + "img/journey-02.0753337f.png";